//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'
import i18 from '../../../i18'

class Row extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rule: props.rule,
            vatCollectorCodes: props.vatCollectorCodes
        }
    };

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            rule: nextProps.rule,
            vatCollectorCodes: nextProps.vatCollectorCodes,
        });
    };

    onEditRule = (event) => {
        this.props.onEditRule(this.state.rule)
    };

    onRemoveRule = (event) => {
        this.props.onRemoveRule(this.state.rule)
    };

    render() {
        let collectorCode = null;
        for (let index in this.state.vatCollectorCodes) {
            if (this.state.rule.vat_collector_id == this.state.vatCollectorCodes[index].id) {
                collectorCode = this.state.vatCollectorCodes[index].code;
            }
        }

        return (
            <tr>
                <td>{this.state.rule.supplier_name}</td>
                <td>{this.state.rule.item_name}</td>
                <td>{this.state.rule.main_bookkeeping_number}</td>
                <td>{this.state.rule.vat}%</td>
                <td>{collectorCode}</td>
                <td>{this.state.rule.vat_degree}</td>
                <td>{this.state.rule.type === 'final' ? i18.COMMON._finalRule : i18.COMMON._temporarirlyRule}</td>
                <td>{this.state.rule.updated_at}</td>
                <td>
                    <i onClick={(event) => this.onEditRule(event)} title={i18.SUPPLIER._editRule} className='fa fa-pencil-square-o' aria-hidden='true'></i> &nbsp;&nbsp;
                    <i onClick={(event) => this.onRemoveRule(event)} title={i18.SUPPLIER._deleteRule} className='fa fa-trash-o' aria-hidden='true'></i>
                </td>
            </tr>
        )
    }
}

export default Row;


// WEBPACK FOOTER //
// ./src/components/supplier/rules/row.js